export type RulingEphemerisPoint = {
  key: string; name: string; sign: string; signAbbr: string;
  degree: { formatted: string }; longitude: number;
  signLord: string; starLord: string; subLord: string; subSubLord: string; isRetrograde: boolean;
};
export type RulingEphemerisData = {
  month: string; time: string; timezone: string; ayanamshaMode: string; nodeMode: string;
  location: { city: string; latitude: number; longitude: number };
  planets: { key: string; name: string }[];
  rows: { date: string; dayName: string; planets: Record<string, RulingEphemerisPoint>;
    rulingPlanets: Record<string, any> }[];
};
export const DELHI_EPHEMERIS_LOCATION = {
  city: 'New Delhi', latitude: 28.6139, longitude: 77.209, timezone: 'Asia/Kolkata',
};
export function ephemerisLocation(city: any) {
  const lat = city?.coordinates?.latitude;
  const lon = city?.coordinates?.longitude;
  if (lat == null || lon == null || !Number.isFinite(Number(lat)) || !Number.isFinite(Number(lon))) return DELHI_EPHEMERIS_LOCATION;
  return { city: city.displayName || city.name || 'Selected location', latitude: Number(lat), longitude: Number(lon),
    timezone: city.timezone?.name || String(city.timezone?.offset ?? '+05:30') };
}
export function currentEphemerisMonth() {
  const parts = new Intl.DateTimeFormat('en', { timeZone: 'Asia/Kolkata', year: 'numeric', month: '2-digit' }).formatToParts(new Date());
  return `${parts.find(p => p.type === 'year')?.value}-${parts.find(p => p.type === 'month')?.value}`;
}
export function shiftEphemerisMonth(month: string, delta: number) {
  if (!/^\d{4}-\d{2}$/.test(month)) return month;
  const [year, number] = month.split('-').map(Number);
  const date = new Date(Date.UTC(year, number - 1 + delta, 1));
  return `${date.getUTCFullYear()}-${String(date.getUTCMonth() + 1).padStart(2, '0')}`;
}
const ABBR: Record<string, string> = { SUN: 'Su', MOON: 'Mo', MARS: 'Ma', MERCURY: 'Me', JUPITER: 'Ju', VENUS: 'Ve', SATURN: 'Sa', RAHU: 'Ra', KETU: 'Ke' };
export const ephemerisLordAbbr = (lord: string) => ABBR[String(lord).toUpperCase()] || lord || '–';
export const ephemerisLordChain = (point: RulingEphemerisPoint) =>
  [point.signLord, point.starLord, point.subLord, point.subSubLord].map(ephemerisLordAbbr).join('-');
export const RULING_EPHEMERIS_ROLES = ['lagnaLord', 'lagnaStarLord', 'moonSignLord', 'moonStarLord', 'dayLord'];
export const rulingEphemerisChain = (ruling: Record<string, any>) => RULING_EPHEMERIS_ROLES.map(key => ephemerisLordAbbr(ruling[key])).join('-');

// This is a selected-date ephemeris, independent of the natal chart's saved mode.
// Send the effective setting explicitly so chart fetch wrappers cannot replace it.
export function rulingEphemerisHeaders(mode: string, custom?: any): Record<string, string> {
  return { 'x-chart-calculation-version': '1', 'x-chart-ayanamsha': JSON.stringify({ version: 1, mode, ...(mode === 'CUSTOM' ? { custom } : {}) }) };
}
